import { render, staticRenderFns } from "./ScreenAi.vue?vue&type=template&id=87929046&scoped=true"
import script from "./ScreenAi.vue?vue&type=script&lang=js"
export * from "./ScreenAi.vue?vue&type=script&lang=js"
import style0 from "./ScreenAi.vue?vue&type=style&index=0&id=87929046&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87929046",
  null
  
)

export default component.exports